import React, { ChangeEvent, forwardRef, useCallback, useRef } from 'react';
import { useSelector } from 'react-redux';

import { Input, InputProps } from 'app/design-system/components/Input';
import { clientId as selectClientId } from 'app/lib/account/selectors';
import { analyticsInputHandler, useAuthorizedInfo } from 'app/packages/analytics';
import { allowGoogleTagManager } from 'app/ssr/config';

//---

const InputWithAnalytics = forwardRef<HTMLInputElement, InputProps>(({
  onChange,
  ...props
}, ref) => {
  const userId = useSelector(selectClientId);

  const isChanged = useRef(false);
  const authorizedInfo = useAuthorizedInfo({ userId });

  const changeHandler = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(event);
    }

    if (!isChanged.current && allowGoogleTagManager) {
      analyticsInputHandler(event.target, authorizedInfo);
      isChanged.current = true;
    }
  }, [props.value, isChanged.current, authorizedInfo]);

  return (
    <Input {...props}
           onChange={changeHandler}
           ref={ref} />
  );
});

export default InputWithAnalytics;
